import React, { useMemo } from 'react';
import { Button, Typography, useGlobalContext } from 'seagull';
import styles from "../ServicesSection.module.scss";
import { ManageDeliveryModal } from "../../ManageDeliveryModal/ManageDeliveryModal";
import { serviceModel } from "../../../../../models";
export default function DeliveryServiceBillingItem(props) {
  const {
    name,
    costDisplay,
    unitCapDisplay,
    service,
    idx,
    agreement,
    billCommands,
    onRefresh
  } = props;
  const firstBillCommand = billCommands && billCommands[0];
  const globalContext = useGlobalContext();
  const hasPendingAmendment = !!service && (serviceModel.isAwaitingApproval(service.status) || serviceModel.isAmended(service.status));
  const deliveryStatus = useMemo(() => {
    if (firstBillCommand) {
      if (firstBillCommand.status === 'rejected') {
        return {
          text: 'Delivery was rejected',
          skin: 'error',
          intent: 'rejected'
        };
      }

      if (firstBillCommand.status === 'requiresApproval') {
        return {
          text: 'Pending approval',
          skin: 'warning',
          intent: 'pendingApproval'
        };
      }
    }

    return null;
  }, [firstBillCommand]);

  const onManageDeliveryClick = async () => {
    const wasDeliverySent = await globalContext.showModal({
      shouldBlurBackground: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ManageDeliveryModal, {
          relationship: agreement,
          billCommand: firstBillCommand,
          service: service,
          onRefresh: onRefresh,
          dismissModal: dismissModal
        });
      }
    });

    if (wasDeliverySent) {
      await onRefresh();
      globalContext.showSuccessToast('Delivery sent to client', 'delivery-success-toast');
    }
  };

  return /*#__PURE__*/React.createElement("li", {
    "data-testid": "service-".concat(idx),
    className: styles.serviceBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.serviceDescription
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "name"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: styles.cost
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "cost",
    variant: "paragraph2",
    skin: "secondary"
  }, costDisplay), unitCapDisplay && /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "unit-cap",
    variant: "paragraph2",
    skin: "secondary"
  }, unitCapDisplay)), deliveryStatus && /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph3",
    skin: deliveryStatus.skin,
    "data-testid": "billing-control-delivery-status",
    "data-intent": deliveryStatus.intent
  }, deliveryStatus.text)), /*#__PURE__*/React.createElement("div", {
    className: styles.lineItemAction
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    "data-testid": "billing-control-manage-delivery-".concat(service === null || service === void 0 ? void 0 : service.id),
    disabled: hasPendingAmendment,
    onClick: onManageDeliveryClick
  }, "Manage delivery")));
}